import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Router} from "@angular/router";
import {ImpressaoService} from "../../services/impressao.service";
import {PedidosService} from "../../services/pedidos.service";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {LayoutPedido} from "../../services/impressao/LayoutPedido";
import {ProcessadorReciboTexto} from "../../services/impressao/ProcessadorReciboTexto";
import {GrupolojasService} from "../../superadmin/services/grupolojas.service";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'info-pedido',
  templateUrl: './info-pedido.component.html',
  styleUrls: ['./info-pedido.component.scss']
})
export class InfoPedidoComponent implements OnInit, OnChanges {
  @Input()
  public pedido: any;
  @Input()
  public contato: any;
  public empresa: any = {}
  @Input()
  public permiteAlterarStatus: boolean;
  @Input()
  public permiteEditarPedido = false;
  @Input() modal: any = false;
  @Input() modoGrupoLojas = false;
  imprimindo: boolean;
  configImpressao: any;
  impressoras = [];

  constructor(private router: Router, private impressao: ImpressaoService,
              private constantsService: ConstantsService,
              private pedidosService: PedidosService,
              private grupolojasService: GrupolojasService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes && (changes.pedido || changes.modoGrupoLojas))
      this.apliqueEmpresaDoPedidoEmModoGrupo();
  }

  ngOnInit() {
    this.constantsService.empresa$.subscribe((empresa) => {
      if(empresa && !this.modoGrupoLojas){
        this.empresa = empresa;
        this.configImpressao = this.empresa.configImpressao;
        this.carregueImpressorasConfiguradas();
      }
    })

    this.apliqueEmpresaDoPedidoEmModoGrupo();
  }

  private apliqueEmpresaDoPedidoEmModoGrupo() {
    if(this.modoGrupoLojas && this.pedido?.empresa){
      this.empresa = this.pedido.empresa;
      this.configImpressao = this.empresa.configImpressao;
      this.carregueImpressorasConfiguradas();
    }
  }

  carregueImpressorasConfiguradas() {
    const impressorasConfiguradas = this.configImpressao?.impressoras || [];
    this.impressoras = impressorasConfiguradas.filter((impressora: any) => impressora && !impressora.removida);
  }

  exibeSeletorImpressoras(): boolean {
    return !!this.configImpressao?.multiplasImpressoras && this.impressoras.length > 1;
  }

  possuiImpressoraUnicaConfigurada(): boolean {
    return !!this.configImpressao?.multiplasImpressoras && this.impressoras.length === 1;
  }

  obtenhaImpressoraPadrao(): any {
    return this.impressoras[0] || null;
  }

  mudarStatus(pedido: any) {
    this.router.navigateByUrl('/admin/pedidos/mudar-status/' + pedido.codigo + '?urlRetorno=' + location.pathname, {
      state: {pedido:  pedido, contato: this.contato, empresa: this.empresa}
    } );
  }

  verPedido(pedido: any){
    if(this.modoGrupoLojas && pedido?.empresa?.id) {
      this.router.navigateByUrl(String(`/admin-grupo/pedidos/detalhes/${pedido.empresa.id}/${pedido.guid}?urlRetorno=${location.pathname}`),
        { state: pedido });
      return;
    }

    this.router.navigateByUrl(  String(`/admin/pedidos/detalhes/${pedido.guid}?urlRetorno=${location.pathname}`),
      { state: pedido });
  }


  imprimaPedidoResumido(){
    this.imprimaPedido('PedidoResumido')
  }

  imprimaPedidoDoLayout(){
    this.imprimaPedido(this.configImpressao ? this.configImpressao.layoutPedido : null  )
  }

  imprimaPedido(layoutPedido: string = 'PedidoCompleto') {
    if(!this.configImpressao  || !this.configImpressao.imprimirTXT)
      window.open('/imprimir/pedido/' + this.pedido.guid + '?l=' + layoutPedido);
    else
      this.imprimaNativamente(null, layoutPedido)
  }

  imprimaNativamente(impressora: any = null, layoutPedido: string  = null ) {
    const impressoraSelecionadaBase = impressora || this.obtenhaImpressoraPadrao();

    if(!impressoraSelecionadaBase) {
      this.impressao.onErrosImpressao.emit('Nenhuma impressora configurada');
      return;
    }

    const impressoraSelecionada = {...impressoraSelecionadaBase};
    const layout = this.obtenhaLayoutPadrao(impressoraSelecionada, layoutPedido);

    if(layout)
      impressoraSelecionada.layout = layout;

    this.imprimaAutomaticamente(impressoraSelecionada);
  }

  imprimaAutomaticamente(impressora: any) {
    this.imprimindo = true;

    //todo: tiranda codigo que verifica tah carregado pelos itens ( pode vim brindes carregados, extra pedido) fazer analise depois
    this.getService().obtenhaPorCodigo(this.pedido.guid, this.pedido?.empresa?.id).then( (pedidoCompleto) => {
      this.imprimaPedidoNaImpressora(pedidoCompleto, impressora);
    }).catch((err) => {
       console.error(err)
      this.imprimindo = false;
    });

  }

  getService(): any {
    if(this.modoGrupoLojas)
      return this.grupolojasService;

    return this.pedidosService;
  }

  private async imprimaPedidoNaImpressora(pedidoCompleto, impressora: any) {
    try {
      await this.impressao.imprimaPedidoNaImpressora(pedidoCompleto, impressora)
      this.imprimindo = false;
    } catch (erro) {
      this.imprimindo = false;
      console.error(erro)
      alert("Houve um erro ao imprimir: " + erro)
    }
  }

  private obtenhaLayoutPadrao(impressora: any = null, layoutPedido: string = null): string {
    let layout = layoutPedido || impressora?.layout || this.configImpressao?.layoutPedido;

    if(layout === 'Completo')
      return 'PedidoCompleto';

    if(layout === 'Resumido')
      return 'PedidoResumido';

    if(layout === 'Ambos')
      return 'PedidoCompleto';

    return layout;
  }

  editar(pedido: any, event = null) {
    if(this.permiteEditarPedido)
      this.router.navigateByUrl('/pedidos/' + pedido.codigo);

    if(event){
      event.stopPropagation();
      event.preventDefault();
    }

    return false;
  }


  async copiarLinkPagamento(pedido: any) {
    if(!pedido?.linkPagamento && !pedido?.guid)
      return;

    const origem = this.modoGrupoLojas && pedido.empresa?.dominio
      ? `https://${pedido.empresa.dominio}.meucardapio.ai`
      : window.location.origin;
    const linkPagamento = pedido.linkPagamento ||
      `${origem}/loja/pedido/acompanhar/${pedido.guid}?pgonline=loja`;
    const nomeContato = this.contato?.nome || pedido.contato?.nome || 'Cliente';
    const mensagem = `${nomeContato}, segue o link de pagamento:\n\n${linkPagamento}`;

    try {
      if(navigator.clipboard && window.isSecureContext)
        await navigator.clipboard.writeText(mensagem);
      else
        this.copiarLinkPagamentoFallback(mensagem);

      pedido.linkPagamentoCopiado = true;
      setTimeout(() => pedido.linkPagamentoCopiado = false, 3000);
    } catch(erro) {
      this.copiarLinkPagamentoFallback(mensagem);
    }
  }

  private copiarLinkPagamentoFallback(link: string) {
    const campo = document.createElement('textarea');
    campo.value = link;
    campo.style.position = 'fixed';
    campo.style.opacity = '0';
    document.body.appendChild(campo);
    campo.select();
    document.execCommand('copy');
    document.body.removeChild(campo);
  }
}
